module.exports = __webpack_public_path__ + "static/media/Frost_ Andrei_MD.f7034219.jpg";